import React from 'react'
import { FormControl, Button, Grid } from '@mui/material'
import { UploadCloud, XCircle } from 'react-feather'

import { FileManagerInput, LinearLoading } from 'common'
import { FilesTable } from './FilesTable'

const acceptConfiguration = {
    'image/jpeg': ['.jpeg', '.jpg'],
    'image/png': ['.png'],
    'application/pdf': []
}
export const FileMaganerSection = ({ useFetchInit, readOnlyMode }) => {

    const { 
        //------------- Generales
        // location,
        // paramsURL,
        //------------- globalStates
        // globalStates,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions,
        //------------- helpers
        // Helpers,
        //------------- Formularios
        Forms
        
    } = useFetchInit

    // ------------------------------------------------ Generales
        
    // ------------------------------------------------ globalStates
    // const {formOpeningMode} = globalStates

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormFiles } = Forms
    const { formState, onDropZoneAcceptedFilesChange, onDropZoneRejectionsFilesChange } = FormFiles
    
    // ------------------------------------------------ FetchData
    const { fetchAllFiles } = FetchData
    const { loadingFetchInfoFiles } = fetchAllFiles
    
    // ------------------------------------------------ Actions
    const { onSubmitFormFiles, handleClickCleanUpFiles } = Actions
    
    return ( 
        <>
            <div className="border-bottom border-dark"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 3}}>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 2 }}>
                    {/* <form onSubmit={onSubmitFormFiles}> */}
                        <div className="text-center">
                            <Button
                                startIcon= {<UploadCloud/>}
                                variant="contained"
                                type="button"
                                style={{background: "#4b4b4c"}}
                                onClick={onSubmitFormFiles}
                                disabled={ readOnlyMode }
                            >
                                Subir
                            </Button>
                            <Button
                                startIcon={<XCircle/>}
                                variant="contained"
                                type="button"
                                onClick={handleClickCleanUpFiles}
                                style={{background: "#ef8157"}}
                                disabled={ readOnlyMode }
                            >
                                Limpiar
                            </Button>
                        </div>
                        <div className="pt-2"></div>
                        <FormControl fullWidth>
                            <label htmlFor="attachmentt"> * Documentos para enviar a revisión </label>
                            <FileManagerInput
                                // datos (listados, individuales)
                                acceptedFiles={formState.acceptedFiles}
                                fileRejections={formState.fileRejections}
                                NameId='attachmentt'
                                typeFiles='IMAGENES - PDF'
                                maxFiles={4}
                                accept={acceptConfiguration}

                                // HandleClicks

                                // Funciones
                                setAcceptedFiles={onDropZoneAcceptedFilesChange}
                                setFileRejections={onDropZoneRejectionsFilesChange}
                            />
                        </FormControl>
                    {/* </form> */}
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={8} sx={{ mb: 2 }}>
                {loadingFetchInfoFiles && ( <LinearLoading /> )}
                    <FilesTable
                        useFetchInit = {useFetchInit}
                        readOnlyMode = {readOnlyMode}
                    />
                </Grid>
            </Grid>
            <div className="border-bottom border-secondary m-3"></div>
        </>
    )
}
